function moneyFormatFunc(amount, format) {
  const normalizedAmount = amount / 100;
  return normalizedAmount.toLocaleString('en-US', {
    style: 'currency',
    currency: format
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const element = document.querySelector('product-recs')
  const mainContainer = document.querySelector('.sc-product-recommendations')

  if(element.querySelectorAll('.product-recs-card').length > 0) return;

    const productId = element.dataset.productId;
    const moneyFormat = Shopify.currency.active;
    let apiUrl = '/recommendations/products.json?limit=4';

    if(productId) {
      apiUrl += `&product_id=${productId}`;

      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          if(data.products.length < 1) {
            return mainContainer.remove()
          }
          if(data.products && data.products.length > 0) {
            element.innerHTML = '';
            data.products.forEach(product => {
              const secondImage = product.images && product.images.length > 1 ? product.images[1] : null;
              const cardHtml = `
                <div class="product-recs-card">
                  <a href="/products/${product.handle}">
                    <div class="product-recs-card_main">
                      <div class="recs-card_photo">
                        <img src="${product.featured_image || ''}" alt="${product.title}" class="scale-125" width="398" height="505">
                      </div>
                      <div class="recs-card_text-content">
                        <div class="card-title">${product.title}</div>
                        <div class="card-price">${moneyFormatFunc(product.price, moneyFormat)}</div>
                      </div>
                    </div>
                    <div class="product-recs-card_sub">
                      <div class="recs-pos-photo">
                        ${secondImage ? `<img src="${secondImage}" alt="${product.title}" width="398" height="505">` : ''}
                      </div>
                      <div class="grid-size-buttons">
                        ${(() => {
                          // Only show unique option1 (size) once — avoid duplicates from Color x Size variants
                          const seen = new Set();
                          return product.variants
                            .filter((variant) => {
                              if (!variant.option1 || seen.has(variant.option1)) return false;
                              seen.add(variant.option1);
                              return true;
                            })
                            .map((variant) => `
                              <a href="/products/${product.handle}?variant=${variant.id}">
                                <div class="sc-button-flat btn-fs" data-variant-id="${variant.id}">
                                  <span>${variant.option1}</span>
                                </div>
                              </a>
                            `)
                            .join('');
                        })()}
                      </div>
                      <div class="bottom-bar"></div>
                    </div>
                  </a>
                </div>
              `;
              element.insertAdjacentHTML('beforeend', cardHtml);
            });
          }
        })
        .catch(error => {
          console.error('Error fetching recommendations:', error);
        });
      }
});